"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE = void 0;
/** @ignore */
const pkgName = process.env.npm_package_name || '';
const pkgVersion = process.env.npm_package_version || '';
/** @ignore */
const SERVICE = `${pkgName}@${pkgVersion}`;
exports.SERVICE = SERVICE;
